"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledQueryListSection = exports.Root = exports.QueriesContainer = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _searchPreviewProduct = require("@ori/search-preview-product");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 1015,
        gap: theme.spacing(4),
        margin: theme.spacing(0, 'auto')
    };
});
const Inner = exports.Inner = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1)
    };
});
const QueriesContainer = exports.QueriesContainer = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(4),
        width: '100%',
        '&:empty': {
            display: 'none'
        }
    };
});
const StyledQueryListSection = exports.StyledQueryListSection = (0, _mui.styled)(_searchPreviewProduct.QueryListSection)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_searchPreviewProduct.queryListSectionClasses.sectionLabel)]: {
            padding: theme.spacing(0, 3)
        },
        [".".concat(_searchPreviewProduct.queryListSectionClasses.queries)]: {
            padding: theme.spacing(0, 3)
        }
    };
});
